function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rojo': 'rgb(213, 189, 229)','beige': 'rgb(243, 232, 216)','azul-claro': 'rgb(211, 170, 170)','violeta': 'rgb(179, 159, 205)','blanco': 'rgb(255, 255, 255)','lila': 'rgb(220, 213, 217)','rojo': 'rgb(255, 0, 0)','verde': 'rgb(0, 128, 0)','azul': 'rgb(81, 123, 173)','negro': 'rgb(0, 0, 0)','azul-oscuro': 'rgb(0, 0, 139)','marron-oscuro': 'rgb(76, 42, 18)','marron-claro': 'rgb(180, 125, 73)','amarillo': 'rgb(255, 255, 0)','azul-marino': 'rgb(0, 0, 139)','rojo-y-negro': 'rgb(255, 0, 0)','negro-y-rojo': 'rgb(0, 0, 0)','rosa': 'rgb(255, 0, 127)','naranja': 'rgb(255, 138, 0)','negro-y-blanco': 'rgb(255, 255, 255)','negro-y-dorado': 'rgb(255, 215, 0)','verde-claro': 'rgb(152, 251, 152)','verde-oliva': 'rgb(128, 128, 0)','azul-y-negro': 'rgb(81, 123, 173)','gris-y-negro': 'rgb(128, 128, 128)','beige': 'rgb(245, 245, 220)','verde-oscuro': 'rgb(0, 100, 0)','gris': 'rgb(128, 128, 128)','naranja': 'rgb(255, 138, 0)','burdeos': 'rgb(114, 47, 55)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
